/* eslint-disable react/prop-types */
import { Grid, Box } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Dropdown from "../../../../components/common/new/Dropdown/Dropdown";
import Typography from "../../../../components/common/new/Typography/Typography";
import styles from "../GohonzonSubmission.styles";
import { selectAllSIUsers } from "../../../../redux/selectors/user";

function HomeVisitedRecommended({
  chapterIds,
  options,
  setChapterIds,
  submittedBy,
}) {
  const { isHelpDesk, isRegionSi, isChapterSi, isZoneSi, isHelpDeskAdmin } =
    useSelector(selectAllSIUsers);
  const { type } = useParams();
  const isReturn = type === "return";

  return (
    <Box my={8}>
      <Grid container>
        <Grid item xs={12}>
          {!isReturn &&
            (isHelpDesk || isHelpDeskAdmin || isZoneSi || isRegionSi) && (
              <>
                <Box
                  style={{
                    width: "280px",
                    height: "44px",
                    flexShrink: "0",
                    borderRadius: "35px",
                    background: "#196AAB",
                    marginBottom: "-25px",
                    position: "relative",
                    zIndex: "1",
                    marginLeft: "45px",
                  }}
                >
                  <Typography
                    variant="title3"
                    style={{
                      color: "#FFF",
                      fontFeatureSettings: "'clig' off, 'liga' off",
                      fontFamily: "Noto Sans",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: "600",
                      lineHeight: "20px",
                      padding: "12px 20px 12px 20px",
                    }}
                  >
                    Home visit & Recommendation
                  </Typography>
                </Box>
                <Box
                  style={{
                    borderRadius: "5px 5px 5px 5px",
                    border: "1px solid #C2D4EB",
                    background: "#F6F6F6",
                    padding: "30px 30px 20px 20px",
                    borderBottom: "9px solid #196AAB",
                    margin: "0px 20px",
                  }}
                >
                  <Box
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      maxWidth: "80%",
                      gap: "40px",
                    }}
                  >
                    <Box flex={1.35} width="60%">
                      <Typography variant="mini" color="#5e5e5e" weight={600}>
                        HOME VISITED AND RECOMMENDED BY :
                      </Typography>
                      <Typography variant="small" color="#FF6A69">
                        *
                      </Typography>
                    </Box>
                    <Box flex={1} style={styles.readOnlyInterviewBy}>
                      <Box style={styles.interviewByNames}>
                        <Typography>{submittedBy || "NA"}</Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </>
            )}
          {isChapterSi && (
            <>
              <Box
                style={{
                  width: "280px",
                  height: "44px",
                  flexShrink: "0",
                  borderRadius: "35px",
                  background: "#196AAB",
                  marginBottom: "-25px",
                  position: "relative",
                  zIndex: "1",
                  marginLeft: "45px",
                }}
              >
                <Typography
                  variant="title3"
                  style={{
                    color: "#FFF",
                    fontFeatureSettings: "'clig' off, 'liga' off",
                    fontFamily: "Noto Sans",
                    fontSize: "18px",
                    fontStyle: "normal",
                    fontWeight: "600",
                    lineHeight: "20px",
                    padding: "12px 20px 12px 20px",
                  }}
                >
                  Home visit & Recommendation
                </Typography>
              </Box>
              <Box
                style={{
                  borderRadius: "5px 5px 5px 5px",
                  border: "1px solid #C2D4EB",
                  background: "#F6F6F6",
                  padding: "30px 30px 20px 20px",
                  borderBottom: "9px solid #196AAB",
                  margin: "0px 20px",
                }}
              >
                <Box
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Box flex={1} width="50%">
                    <Typography variant="mini" color="#5e5e5e" weight={600}>
                      HOME VISITED AND RECOMMENDED BY :
                      <Typography variant="small" color="#FF6A69">
                        *
                      </Typography>
                    </Typography>
                  </Box>
                  <Box flex={1} style={{ maxWidth: "80%" }}>
                    <Dropdown
                      name="chapterId"
                      value={chapterIds}
                      options={options}
                      label="Select Chapter Chief"
                      onChange={(e) => setChapterIds(e.target.value)}
                    />
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </Grid>
      </Grid>
    </Box>
  );
}

export default HomeVisitedRecommended;
